// Core component styles
const coreStyles={container:{height:'100%',width:'100%'}};/**
 * Helper method to get styles for the Power BI
 * @param {Object} contextStyles - Custom styles for the PowerBI component
 */const getStyles=function(){let contextStyles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{container:{...coreStyles.container,...contextStyles.container}};};export default getStyles;